jQuery(document).ready(function(){
	var readmore = false;
	var readMoreButtonEle = jQuery("#readmore-btn");
	var readMoreButtonContainerEle = jQuery("#readmore-btn-container");
	var readMoreContentEle = jQuery("#readmore-container");
	var readLessContentClass = "lesscontent";
	var readMoreText = "Read More";
	var readLessText = "Read Less";

	readMoreButtonEle.click(function(){
		if(readmore){
			readMoreButtonEle.text(readMoreText);
			readMoreContentEle.addClass(readLessContentClass);
			readMoreButtonContainerEle.addClass(readLessContentClass);
		}else{
			readMoreButtonEle.text(readLessText);
			readMoreContentEle.removeClass(readLessContentClass);
			readMoreButtonContainerEle.removeClass(readLessContentClass);
		}
		readmore = !readmore;
	});
});